import React, {useState, useEffect} from "react";
import {crud} from "../crudRequests";
import {lightFormat} from "date-fns";
import {Box, Table, Thead, Tbody, Tr, Th, Td} from "@chakra-ui/react";

export default function LoginHistory({dashState}) {
  const [logins, setLogins] = useState([]);
  const {patient, relationship} = dashState;
  useEffect(() => {
    crud(dashState, [
      {
        db: dashState.db,
        collection: "security",
        parameters: [
          {
            userId:
              dashState?.userType === "patient"
                ? patient?.pid
                : relationship?.rid,
          },
        ],
        method: "findOne",
      },
    ])
      .then((res) => {
        setLogins((res.data[0]?.logins || []).reverse());
      })
      .catch((e) => {
        console.log(e.message);
      });
  }, []);

  return (
    <Box
      borderWidth="1px"
      borderColor="gray.100"
      rounded="lg"
      overflow="hidden"
    >
      <Box maxH="220px" overflowY="auto" className="sbar3">
        <Table size="sm" variant="simple">
          <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
            <Tr>
              <Th fontSize="xs" color="gray.500" fontWeight="500" textTransform="none" letterSpacing="0">Date/Time</Th>
              <Th fontSize="xs" color="gray.500" fontWeight="500" textTransform="none" letterSpacing="0">IP Address</Th>
              <Th fontSize="xs" color="gray.500" fontWeight="500" textTransform="none" letterSpacing="0">Device</Th>
            </Tr>
          </Thead>
          <Tbody>
            {logins.length === 0 && (
              <Tr>
                <Td colSpan={3} textAlign="center" py={6} color="gray.400" fontSize="sm">
                  No login activity recorded
                </Td>
              </Tr>
            )}
            {logins.map((log, i) => (
              <Tr key={i} _hover={{bg: "gray.25"}}>
                <Td fontSize="xs" color="gray.700">
                  {lightFormat(new Date(log.timestamp), "dd/MM/yy HH:mm")}
                </Td>
                <Td fontSize="xs" color="gray.500">{log.ip?.toString() || ""}</Td>
                <Td fontSize="xs" color="gray.500" maxW="180px" isTruncated>{log.client?.toString() || ""}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}
